import css from './paginated-footer.module.scss';

interface PaginatedFooterProps {
  caption: string;
  onClick: () => void;
  disabled?: boolean;
}

export default function PaginatedFooter({ caption, onClick, disabled }: Readonly<PaginatedFooterProps>) {
  return (
    <div className={css.paginatedFooter}>
      <div className={css.line} />
      <button disabled={disabled} onClick={onClick}>
        {caption}
      </button>
      <div className={css.line} />
    </div>
  );
}
